import Vue from "vue";
import Router from "vue-router";

import AuthService from "@/services/AuthService";
import { Checker } from "@/plugins/acl";

import authRoutes from "@/router/auth";
import patientQueueRoutes from "@/router/patientQueue";
import interviewRoutes from "@/router/interview";
import practiceUsersRoutes from "@/router/practiceUsers";
import practiceRoutes from "@/router/practice";
import encounterRoutes from "@/router/encounter";
import symptomRoutes from "@/router/symptom";
import settingRoutes from "@/router/settings";

import userProfile from "@/components/user/Profile";

import trends from "@/components/trends/Index";

import help from "@/components/Help";
import error from "@/components/Error";

Vue.use(Router);

const router = new Router({
  linkActiveClass: "is-active",
  routes: [
    authRoutes,
    patientQueueRoutes,
    encounterRoutes,
    interviewRoutes,
    practiceRoutes,
    practiceUsersRoutes,
    symptomRoutes,
    settingRoutes,
    {
      path: "/trends",
      name: "trends",
      component: trends,
      meta: {
        title: "Trends",
        permission: "patient_queue:read|patient_queue:manage"
      }
    },
    {
      path: "/profile",
      name: "user-profile",
      component: userProfile,
      meta: {
        title: "Profile",
        permission: "patient_queue:read|user:manage|user:profile"
      }
    },
    {
      path: "/help",
      name: "help",
      component: help,
      meta: {
        title: "Help",
        permission: "any"
      }
    },
    {
      path: "/error",
      name: "error",
      component: error,
      meta: {
        title: "Error",
        permission: "any"
      }
    },
    {
      // catch any 404 paths
      path: "*",
      redirect: "/patient-queue-list",
      meta: {
        permission: "any"
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (typeof to.meta.title !== "undefined") {
    document.title = `${to.meta.title} | Virtriage`;
  }

  if (to.meta.permission !== "any") {
    return AuthService.isLoggedIn()
      .then(() => {
        let go = null;
        if (!Checker.check(to.meta.permission)) {
          go = next("/auth/login");
        } else {
          go = next();
        }
        return go;
      })
      .catch(() => {
        next("/auth/login");
      });
  }
  next();

  return true;
});

export default router;
